module.exports = __webpack_public_path__ + "static/media/YM45_0.5705edd2.jpg";